// extracted by mini-css-extract-plugin
export default {"infoLink":"O9LGbjI42ooFJmiRS_zr","optionLabel":"xlYr7fVLbC803LHi7WYS","catalogLink":"po5vze3s2s8aFeVmqSh0"};